/**
 * Pufien — ürün sayfasında TAHMİNİ TESLİM ARALIĞI (P02, 8 Ekim 2026).
 *
 * ÇIKTI (Sepete Ekle'nin altındaki kutu):
 *   ana satır : "Tahmini teslim: 9-15 Ekim"   (ay değişirse "30 Ekim - 5 Kasım")
 *   alt satır : "13:00'a kadar sipariş verirsen bugün kargoda" / "Yarın kargoda" /
 *               "12 Ekim Pazartesi kargoda"
 *   Kesin tarih ya da "garanti" ifadesi kullanılmaz; her zaman "Tahmini teslim".
 *
 * KURALLAR (kargo politikası + kullanıcı kararı, 8 Ekim 2026)
 *   İş günü        : Pazartesi-Cuma; aşağıdaki resmî tatiller iş günü DEĞİL.
 *   Kargoya veriliş: iş gününde kesim saatine (13:00) kadar → aynı gün;
 *                    sonrası → sonraki iş günü.
 *   Arife          : yarım gün resmî tatil. Kesim saatinden önce aynı gün kargo olur,
 *                    sonrası sonraki iş günü. Teslim süresi sayılırken arife İŞ GÜNÜ
 *                    SAYILMAZ (ihtiyatlı; bayram öncesi dağıtım yarım gün).
 *   Teslim aralığı : kargoya verilişten sonra en az 1, en çok 5 iş günü
 *                    (politika: İstanbul içi 1-2, şehirler arası 2-5 iş günü).
 *   Liste sonu     : tatil listesi TATIL_LISTE_SONU gününe kadar geçerli. Hesap bu tarihi
 *                    aşarsa üst sınır 2 iş günü genişler ve konsola uyarı yazılır —
 *                    sessizce yanlış tarih verilmez.
 *
 * KAYNAKLAR
 *   Sabit tarihli resmî tatiller: 2429 sayılı Ulusal Bayram ve Genel Tatiller Hakkında Kanun.
 *   Dinî bayramlar (2027): Diyanet İşleri Başkanlığı 2027 dini günler listesi —
 *     https://vakithesaplama.diyanet.gov.tr/icerik.php?icerik=154
 *     https://mobil.diyanet.gov.tr/mobile/dinigunler/dinigunler.html   (8 Ekim 2026'da okundu)
 *     Ramazan Bayramı 9-11 Mart 2027 (arife 8 Mart), Kurban Bayramı 16-19 Mayıs 2027 (arife 15 Mayıs).
 *   2026'nın dinî bayramları (Mart ve Mayıs) bu listenin başlangıcından önce kaldı.
 *   ⚠️ 2028 için liste güncellenmeli: 2028 Ramazan ve Kurban Bayramı tarihleri Diyanet'ten alınır.
 *
 * NEDEN JS, NEDEN Europe/Istanbul: Shopify CDN sayfayı önbelleğe alır; Liquid ile basılan saat
 * donar. Hesap tarayıcıda, İstanbul'un takvim günü ve saatiyle yapılır; ziyaretçinin saat dilimi
 * sonucu değiştirmez.
 */
(function () {
  var TZ = 'Europe/Istanbul';
  var DEFAULT_CUTOFF_HOUR = 13;
  var DEFAULT_MIN_DAYS = 1;
  var DEFAULT_MAX_DAYS = 5;
  var EXPIRED_EXTRA_DAYS = 2;

  /** Tam gün resmî tatiller (kargo çıkışı ve teslim yok). */
  var TATIL = {
    '2026-10-29': 'Cumhuriyet Bayramı',
    '2027-01-01': 'Yılbaşı',
    '2027-03-09': 'Ramazan Bayramı 1. gün',
    '2027-03-10': 'Ramazan Bayramı 2. gün',
    '2027-03-11': 'Ramazan Bayramı 3. gün',
    '2027-04-23': 'Ulusal Egemenlik ve Çocuk Bayramı',
    '2027-05-01': 'Emek ve Dayanışma Günü',
    '2027-05-16': 'Kurban Bayramı 1. gün',
    '2027-05-17': 'Kurban Bayramı 2. gün',
    '2027-05-18': 'Kurban Bayramı 3. gün',
    '2027-05-19': 'Kurban Bayramı 4. gün · Atatürk\'ü Anma, Gençlik ve Spor Bayramı',
    '2027-07-15': 'Demokrasi ve Millî Birlik Günü',
    '2027-08-30': 'Zafer Bayramı',
    '2027-10-29': 'Cumhuriyet Bayramı',
  };
  /** Yarım gün resmî tatiller (arifeler, 13:00'ten sonra tatil). */
  var ARIFE = {
    '2026-10-28': 'Cumhuriyet Bayramı arifesi',
    '2027-03-08': 'Ramazan Bayramı arifesi',
    '2027-05-15': 'Kurban Bayramı arifesi',
    '2027-10-28': 'Cumhuriyet Bayramı arifesi',
  };
  var TATIL_LISTE_SONU = '2027-12-31';

  var DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  var MONTHS = [
    'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
    'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
  ];

  /** İstanbul'un takvim günü + saati — ziyaretçinin saat diliminden bağımsız. */
  function istanbulNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());

    var get = function (type) {
      var p = parts.find(function (x) { return x.type === type; });
      return p ? parseInt(p.value, 10) : 0;
    };

    // hour12:false bazı tarayıcılarda gece yarısını "24" verir
    var hour = get('hour');
    if (hour === 24) hour = 0;

    return { year: get('year'), month: get('month'), day: get('day'), hour: hour };
  }

  function pad2(n) { return n < 10 ? '0' + n : '' + n; }

  /** "2026-10-29" — tatil anahtarı ve <time datetime>. */
  function isoDate(d) {
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  }

  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }

  function isWeekend(d) {
    var g = d.getDay();
    return g === 0 || g === 6;
  }

  function isHoliday(d) { return Object.prototype.hasOwnProperty.call(TATIL, isoDate(d)); }
  function isArife(d) { return Object.prototype.hasOwnProperty.call(ARIFE, isoDate(d)); }
  function isBeyondList(d) { return isoDate(d) > TATIL_LISTE_SONU; }

  /** Kargo çıkışı yapılabilen gün: hafta içi ve tam gün tatil değil (arife, kesimden önce olur). */
  function isShipDay(d) { return !isWeekend(d) && !isHoliday(d); }

  /** Teslim süresinde sayılan gün: hafta içi, tatil değil, arife değil. */
  function isTransitDay(d) { return !isWeekend(d) && !isHoliday(d) && !isArife(d); }

  /** n teslim iş günü ekle. */
  function addTransitDays(date, n) {
    var d = new Date(date.getTime());
    var count = 0;
    while (count < n) {
      d = addDays(d, 1);
      if (isTransitDay(d)) count++;
    }
    return d;
  }

  /** Sonraki kargo günü (bugün hariç). */
  function nextShipDay(date) {
    var d = addDays(date, 1);
    while (!isShipDay(d)) d = addDays(d, 1);
    return d;
  }

  /** "9-15 Ekim" · "30 Ekim - 5 Kasım" */
  function trRange(a, b) {
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) {
      return a.getDate() + '-' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    }
    return a.getDate() + ' ' + MONTHS[a.getMonth()] + ' - ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
  }

  /** trRange'in <time datetime> etiketli hâli. */
  function trRangeHtml(a, b) {
    var t = function (d, text) { return '<time datetime="' + isoDate(d) + '">' + text + '</time>'; };
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) {
      return t(a, '' + a.getDate()) + '-' + t(b, b.getDate() + ' ' + MONTHS[b.getMonth()]);
    }
    return t(a, a.getDate() + ' ' + MONTHS[a.getMonth()]) + ' - ' + t(b, b.getDate() + ' ' + MONTHS[b.getMonth()]);
  }

  /** "12 Ekim Pazartesi" */
  function trDate(d) {
    return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + DAYS[d.getDay()];
  }

  var warned = false;

  /**
   * Saf hesap — DOM'a dokunmaz, test edilebilir.
   * @param {number} cutoffHour  kesim saati (0-23)
   * @param {number} minDays     kargodan sonra en az kaç teslim iş günü
   * @param {number} maxDays     kargodan sonra en çok kaç teslim iş günü
   * @param {object} [nowOverride] {year, month, day, hour} — yalnız test için
   */
  function compute(cutoffHour, minDays, maxDays, nowOverride) {
    var now = nowOverride || istanbulNow();
    var today = new Date(now.year, now.month - 1, now.day);

    // --- Kargoya veriliş günü ---
    var sameDay = isShipDay(today) && now.hour < cutoffHour;
    var ship = sameDay ? today : nextShipDay(today);

    // --- Teslim aralığı ---
    var min = addTransitDays(ship, minDays);
    var max = addTransitDays(ship, maxDays);

    // --- Tatil listesi bitti mi? ---
    var expired = isBeyondList(today) || isBeyondList(max);
    if (expired) {
      max = addTransitDays(ship, maxDays + EXPIRED_EXTRA_DAYS);
      if (!warned && typeof console !== 'undefined' && console.warn) {
        console.warn('[pf-shipping-eta] Tatil listesi ' + TATIL_LISTE_SONU +
          ' tarihinde bitti; teslim aralığı ' + EXPIRED_EXTRA_DAYS + ' iş günü genişletildi. Listeyi güncelleyin.');
        warned = true;
      }
    }

    // --- Alt satır ---
    var diffDays = Math.round((ship - today) / 86400000);
    var shipLabel;
    if (diffDays === 0) {
      shipLabel = pad2(cutoffHour) + ":00'a kadar sipariş verirsen bugün kargoda";
    } else if (diffDays === 1) {
      shipLabel = 'Yarın kargoda';
    } else {
      shipLabel = trDate(ship) + ' kargoda';
    }

    var range = trRange(min, max);
    var etaHtml = 'Tahmini teslim: <strong>' + trRangeHtml(min, max) + '</strong>';

    return {
      sameDay: sameDay,
      ship: ship,
      min: min,
      max: max,
      expired: expired,
      shipLabel: shipLabel,
      etaHtml: etaHtml,
      etaText: 'Tahmini teslim: ' + range,
    };
  }

  function intAttr(el, name, fallback) {
    if (!el) return fallback;
    var raw = el.getAttribute(name);
    if (raw == null || raw === '') return fallback;
    var n = parseInt(raw, 10);
    return isNaN(n) ? fallback : n;
  }

  function fillPair(etaEl, shipEl, box) {
    var cutoff = intAttr(box, 'data-pf-cutoff', DEFAULT_CUTOFF_HOUR);
    var minDays = intAttr(box, 'data-pf-transit-min', DEFAULT_MIN_DAYS);
    var maxDays = intAttr(box, 'data-pf-transit-max', DEFAULT_MAX_DAYS);
    if (cutoff < 0 || cutoff > 23) cutoff = DEFAULT_CUTOFF_HOUR;
    if (minDays < 1 || minDays > 30) minDays = DEFAULT_MIN_DAYS;
    if (maxDays < minDays || maxDays > 30) maxDays = Math.max(minDays, DEFAULT_MAX_DAYS);

    var r = compute(cutoff, minDays, maxDays);

    if (etaEl) {
      etaEl.innerHTML = r.etaHtml;
      etaEl.removeAttribute('hidden');
      etaEl.setAttribute('data-pf-ready', '1');
    }
    if (shipEl) {
      shipEl.textContent = r.shipLabel;
      shipEl.removeAttribute('hidden');
      shipEl.setAttribute('data-pf-ready', '1');
    }
    if (box) box.setAttribute('data-pf-ready', '1');
  }

  function render() {
    var filled = 0;

    // Normal yol: her kutu kendi ayarını taşır.
    var boxes = document.querySelectorAll('[data-pf-delivery]:not([data-pf-ready])');
    for (var i = 0; i < boxes.length; i++) {
      fillPair(
        boxes[i].querySelector('[data-pf-eta]'),
        boxes[i].querySelector('[data-pf-ship]'),
        boxes[i]
      );
      filled++;
    }

    // Yedek yol: CDN'de hâlâ ESKİ snippet HTML'i varsa (deploy anı) kutu
    // sarmalayıcısı olmayabilir — yine de tarihi bas, kimse boş kutu görmesin.
    var orphans = document.querySelectorAll('[data-pf-eta]:not([data-pf-ready])');
    for (var j = 0; j < orphans.length; j++) {
      var el = orphans[j];
      var box = el.closest ? el.closest('[data-pf-delivery]') : null;
      var parent = el.parentNode;
      fillPair(el, parent ? parent.querySelector('[data-pf-ship]') : null, box);
      filled++;
    }

    return filled;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  // Horizon bölümleri morph / section-render ile yeniden çiziliyor (varyant
  // değişimi, tema editörü, sepet güncellemesi). Yeniden çizilen HTML Liquid
  // yedek metnini geri getirir; aşağıdaki iki kanca tarihi tekrar basar.
  document.addEventListener('shopify:section:load', render);

  if (typeof MutationObserver === 'function') {
    // NOT: rAF'i window'dan koparıp çağırmak ("Illegal invocation") patlar,
    // bu yüzden her zaman window üzerinden çağrılıyor.
    var schedule = function (fn) {
      if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(fn);
      else window.setTimeout(fn, 0);
    };
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      schedule(function () {
        scheduled = false;
        render();
      });
    });
    var startObserving = function () {
      if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) startObserving();
    else document.addEventListener('DOMContentLoaded', startObserving);
  }

  // QA kancası: konsoldan pfShippingEta.compute(13, 1, 5, {year:2026,month:10,day:27,hour:14})
  window.pfShippingEta = {
    compute: compute,
    render: render,
    tatil: TATIL,
    arife: ARIFE,
    listeSonu: TATIL_LISTE_SONU,
  };
})();
